// Shared status styling + banner used across pages.
import { CheckCircle2, ArrowDownCircle, ArrowUpCircle } from "lucide-react";
import { formatCents } from "@/lib/money";
import { useT, statusLabel } from "@/lib/i18n";

export function computeStatus(differenceCents) {
  if (differenceCents === 0) return "BALANCED";
  if (differenceCents < 0) return "SHORT";
  return "OVER";
}

export const statusStyles = {
  BALANCED: {
    banner: "bg-[#f6f1e3] text-stone-700 border border-[#e7dcc3]",
    light: "bg-emerald-50 text-emerald-900 border-emerald-200",
    badge: "bg-emerald-100 text-emerald-800 border border-emerald-200",
    icon: CheckCircle2,
  },
  SHORT: {
    banner: "bg-rose-50 text-rose-700 border border-rose-200",
    light: "bg-rose-50 text-rose-900 border-rose-200",
    badge: "bg-rose-100 text-rose-800 border border-rose-200",
    icon: ArrowDownCircle,
  },
  OVER: {
    banner: "bg-emerald-50 text-emerald-700 border border-emerald-200",
    light: "bg-amber-50 text-amber-900 border-amber-200",
    badge: "bg-amber-100 text-amber-900 border border-amber-200",
    icon: ArrowUpCircle,
  },
};

export const StatusBanner = ({ status, differenceCents, testid }) => {
  const t = useT();
  const s = statusStyles[status];
  const Icon = s.icon;
  const label =
    status === "BALANCED"
      ? statusLabel(t, status)
      : `${statusLabel(t, status)} ${formatCents(Math.abs(differenceCents))}`;
  return (
    <div
      data-testid={testid}
      className={`flex items-center justify-center gap-3 rounded-2xl px-6 py-6 ${s.banner}`}
    >
      <Icon className="h-9 w-9 shrink-0" />
      <span className="font-display text-4xl font-black tracking-tight tabular-nums">
        {label}
      </span>
    </div>
  );
};

export const StatusBadge = ({ status }) => {
  const t = useT();
  const s = statusStyles[status];
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide ${s.badge}`}
    >
      {statusLabel(t, status)}
    </span>
  );
};
